export default __webpack_public_path__ + "static/media/icon-encanador.155b9c2a.svg";